import type { CadastroAplicativoModel, PromocaoOption } from "../models/cadastroAplicativoModel"

export enum CadastroAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    CARREGAR_PROMOCOES = "CARREGAR_PROMOCOES",
}

export type CadastroAplicativoActionModel =
    | {
          type: CadastroAplicativoActionsTypes.CARREGAR
          payload: CadastroAplicativoModel
      }
    | {
          type: CadastroAplicativoActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof CadastroAplicativoModel; valor: string | number | boolean | null }
      }
    | {
          type: CadastroAplicativoActionsTypes.CARREGAR_PROMOCOES
          payload: PromocaoOption[]
      }
